function greaterThanComparator(
  ruleValue: unknown,
  compareValue: unknown,
): boolean {
  if (typeof ruleValue === 'number' && typeof compareValue === 'number') {
    return compareValue > ruleValue;
  }
  return false;
}

function lessThanComparator(
  ruleValue: unknown,
  compareValue: unknown,
): boolean {
  if (typeof ruleValue === 'number' && typeof compareValue === 'number') {
    return compareValue < ruleValue;
  }
  return false;
}

function greaterThanOrEqualToComparator(
  ruleValue: unknown,
  compareValue: unknown,
): boolean {
  if (typeof ruleValue === 'number' && typeof compareValue === 'number') {
    return compareValue >= ruleValue;
  }
  return false;
}

function lessThanOrEqualToComparator(
  ruleValue: unknown,
  compareValue: unknown,
): boolean {
  if (typeof ruleValue === 'number' && typeof compareValue === 'number') {
    return compareValue <= ruleValue;
  }
  return false;
}

function equalToComparator(ruleValue: unknown, compareValue: unknown): boolean {
  if (typeof ruleValue === 'number' && typeof compareValue === 'number') {
    return ruleValue === compareValue;
  }

  if (typeof ruleValue === 'string' && typeof compareValue === 'string') {
    return ruleValue.localeCompare(compareValue) === 0;
  }

  return false;
}

function notEqualToComparator(
  ruleValue: unknown,
  compareValue: unknown,
): boolean {
  if (typeof ruleValue === 'number' && typeof compareValue === 'number') {
    return ruleValue !== compareValue;
  }

  if (typeof ruleValue === 'string' && typeof compareValue === 'string') {
    return ruleValue.localeCompare(compareValue) !== 0;
  }

  return ruleValue !== compareValue;
}

/**
 * @internal
 * Default comparator map
 */
export const defaultComparators = {
  'greater-than': greaterThanComparator,
  'less-than': lessThanComparator,
  'greater-than-or-equal-to': greaterThanOrEqualToComparator,
  'less-than-or-equal-to': lessThanOrEqualToComparator,
  'equal-to': equalToComparator,
  'not-equal-to': notEqualToComparator,
} as const;
